import axiosClient from "./AxiosConfig";

const DocumentTypeService = {

  async getAll() {
    return await axiosClient.get("/document/types");
  },

  async getById(id) {
    return await axiosClient.get(`/document/types/${id}`);
  },

  async create(documentType) {
    await axiosClient.post("/document/types", documentType);
  },

  async update(documentType) {
    return await axiosClient.put("/document/types", documentType);
  },

  async deleteById(id) {
    return await axiosClient.delete(`/document/types/${id}`);
  }
};

export default DocumentTypeService;
